import { render, staticRenderFns } from "./_custom_field.vue?vue&type=template&id=8f590dda&lang=pug"
import script from "./_custom_field.vue?vue&type=script&lang=js"
export * from "./_custom_field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports